module.exports = __webpack_public_path__ + "static/media/chapterExam.759711d0.png";